import {
  RadioGroup,
  Stack,
  Radio,
  Text,
  Box,
  RadioGroupProps,
} from '@chakra-ui/react'
import { memo } from 'react'
import './styles.scss'

interface Option {
  value: string
  label: string
}

interface CustomRadioGroupProps extends Omit<RadioGroupProps, 'children'> {
  options: Option[]
  label?: string
  error?: string
}

const ChakraRadioGroup: React.FC<CustomRadioGroupProps> = ({
  options,
  label,
  error,
  ...props
}) => {
  return (
    <Box>
      {label && (
        <Text mb={2} fontWeight="medium">
          {label}
        </Text>
      )}
      <RadioGroup
        {...props}
        sx={{
          '.chakra-radio': {
            alignItems: 'flex-start',
          },
          '.chakra-radio__control': {
            marginTop: '3px',
          },
          '.chakra-radio__label': {
            marginTop: '0',
            paddingTop: '0',
            verticalAlign: 'top',
          },
        }}
      >
        <Stack spacing="8px">
          {options.map((option) => (
            <Radio
              key={option.value}
              value={option.value}
              size="md"
              width="100%"
              sx={{
                borderColor: '#141743',
                '.chakra-radio__label': {
                  fontFamily: 'Inter',
                  fontSize: '14px',
                  fontWeight: '400',
                  lineHeight: '20px',
                  letterSpacing: '0%',
                  verticalAlign: 'middle',
                  color: '#1F2937',
                },
                '.chakra-radio__control': {
                  borderColor: '#141743',
                  backgroundColor: 'white',
                  _checked: {
                    backgroundColor: '#141743',
                    borderColor: '#141743',
                  },
                },
              }}
            >
              {option.label}
            </Radio>
          ))}
        </Stack>
      </RadioGroup>
      {error && (
        <Text color="red.500" fontSize="sm" mt={2}>
          {error}
        </Text>
      )}
    </Box>
  )
}

export default memo(ChakraRadioGroup)
